import { render, staticRenderFns } from "./AddChangelogModal.vue?vue&type=template&id=c16f3df8&scoped=true&"
import script from "./AddChangelogModal.vue?vue&type=script&lang=js&"
export * from "./AddChangelogModal.vue?vue&type=script&lang=js&"
import style0 from "./AddChangelogModal.vue?vue&type=style&index=0&id=c16f3df8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16f3df8",
  null
  
)

export default component.exports